import { MobileMenu } from "./module/_m-mobile-menu";
import { Header } from "./module/_m-header";
import { Floating } from "./module/_m-floating";
// import { InquiryForm } from './module/_m-InquiryForm';
import { Accordion } from "./module/_m-accordion";
import { Benefits } from "./module/_m-benefits";
import { TabSwitch } from "./module/_m-tabswitch";
import { FadeAnimation } from "./module/_m-fadeanimation";
import Swiper, { Autoplay, LazyLoad } from 'swiper/bundle';


document.addEventListener("DOMContentLoaded", (e) => {
    new MobileMenu();
    new Header();
    // new InquiryForm();
    new Floating();
    new Accordion();
    new Benefits();


    const tabSwitch = new TabSwitch();
    tabSwitch.init();

    const scrollFade = new FadeAnimation();
    scrollFade.init();


    // ページ内のすべての「.c-img-swiper」を取得してループ処理
    const swiperContainers = document.querySelectorAll('.c-img-swiper');

    swiperContainers.forEach((container) => {
        const swiperTarget = container.querySelector('.swiper');
        const prevButton = container.querySelector('.my-swiper-prev');
        const nextButton = container.querySelector('.my-swiper-next');
        const pagination = container.querySelector('.swiper-pagination');

        // 個別にSwiperを初期化
        new Swiper(swiperTarget, {
            loop: true, // ループ
            speed: 450, // 少しゆっくり

            // ページネーション(コンテナ内のものに限定)
            pagination: {
                el: pagination,
                type: "progressbar",
            },

            // 前後の矢印(コンテナ内のものに限定)
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },

            slidesPerView: 1.5,
            spaceBetween: 15,
            breakpoints: {
                500: {
                    slidesPerView: 2.5,
                },
                980: {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                },
                1600: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            }
        });
    });


    const dialog = document.getElementById('myModal');
    const openBtn = document.getElementById('openBtn');

    // openBtn と dialog の両方が存在する場合のみ実行する
    if (openBtn && dialog) {
        openBtn.addEventListener('click', () => {
            dialog.showModal();
        });
    }



    const jumpBtn = document.querySelector('.c-back-top');
    const footer = document.querySelector('footer');

    if (jumpBtn) {
        window.addEventListener('scroll', () => {
            const scrollY = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const isSp = window.innerWidth <= 767;

            // フッターの表示開始位置(ドキュメントの最上部からの距離)
            const footerTop = footer ? footer.offsetTop : Infinity;

            // 現在の画面下端の位置
            const scrollBottom = scrollY + windowHeight;

            // --- 表示・非表示のロジック ---

            if (isSp) {
                // SPの場合：画面の下端がフッターのTOPを超えたら非表示
                if (scrollBottom > footerTop) {
                    jumpBtn.classList.remove('is-show');
                } else if (scrollY > 1500) {
                    // 1500px以上スクロール、かつフッターより上なら表示
                    jumpBtn.classList.add('is-show');
                } else {
                    jumpBtn.classList.remove('is-show');
                }
            } else {
                // PCの場合：1500px以上で表示(既存の押し上げ処理があるため)
                if (scrollY > 1500) {
                    jumpBtn.classList.add('is-show');
                } else {
                    jumpBtn.classList.remove('is-show');
                }
            }

            // --- PC用の押し上げ処理(既存ロジックを維持) ---
            if (!isSp && footer) {
                const documentHeight = document.documentElement.scrollHeight;
                const distanceFromBottom = documentHeight - scrollBottom;
                const footerHeight = footer.offsetHeight;

                if (distanceFromBottom < footerHeight) {
                    const newBottom = footerHeight - distanceFromBottom + 20;
                    jumpBtn.style.bottom = newBottom + 'px';
                } else {
                    jumpBtn.style.bottom = '20px';
                }
            }
        }, { passive: true });
    }
});
